import React, { useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import { PlaidStatusLoader } from "./PlaidLoadingStates";
import DEATH_API from "../../apis/death.api";
import swal from "sweetalert";

const ShowPlaid = ({ link, tokenState,syncPlaidRecords }) => {
  const [loading, setLoading] = useState(false);

  const config = {
    token: link,
    onSuccess: (public_token, metadata) => {
      console.log("public_token",metadata);
      setPlaidPublicToken(public_token,metadata);
    },
    onExit: (err, metadata) => {
      if (err !== null) {
        console.error("Error:", err);
        console.error("Error:", err.error_code);
        if (err.error_code === "NO_INVESTMENT_ACCOUNTS") {
          swal(
            "Error",
            "There are no valid investment account(s) associated with this Item.",
            "error"
          );
        } else if (err.error_code === "NO_LIABILITY_ACCOUNTS") {
          swal(
            "Error",
            "There are no valid liability account(s) associated with this Item.",
            "error"
          );
        } else {
          swal("Error", err.error_message, "error");
        }
        // Handle the error here
      }
      console.log("Metadata:", metadata);
      // You can also handle different types of exits here
    },
  };

  const { open, ready } = usePlaidLink(config);

  const setPlaidPublicToken = async (publicToken,data) => {
    try {
      setLoading(true);
      let payload={
        public_token: publicToken,
      }
      if(data && data.institution){
        payload = {
          ...payload,
          institutionName:data.institution.name && data.institution.name,
          institutionId:data.institution.institution_id && data.institution.institution_id,
        };
      }
      if(data && data.accounts){
        payload = {
          ...payload,
          accounts: data.accounts,
        };
      }
      let api_res = await DEATH_API.setPlaidPublicToken(payload);
      await syncPlaidRecords();
      tokenState(publicToken);
      console.log("api_res", api_res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      throw new Error(error);
    }
  };
  //   useEffect(() => ready && open(), [open, ready]);
  useEffect(() => {
    if (ready) {
      open();
    }
    console.log("calling useeffctt for open");
  }, [ready]);

  return (
    <div>
      <PlaidStatusLoader 
        isLoading={loading}
        title="Securing Token"
        subtitle="Finalizing bank connection..."
      />
    </div>
  );
};

export default ShowPlaid;
